import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {TOGGLE_SHOW_NOTIFY_VOLUNTEERS_MODAL} from '~/SignUpSheets/reducers/sheet/constants';

export const useUnlockGate = () => {
  const dispatch = useDispatch();

  const handleUnlock = useCallback(() => {
    dispatch({
      type: TOGGLE_SHOW_NOTIFY_VOLUNTEERS_MODAL,
      payload: {show_notify_volunteers_modal: true},
    });
  }, [dispatch]);
  return {handleUnlock};
};
